// todo: move to common
import { paddings, type Scale, tw } from "@sveabank/cc-common";
import type { ReactNode } from "react";

type Props = {
	children: ReactNode;
	hideMobile?: boolean;
	padding?: Scale;
	className?: string;
};

const Paper = ({ children, hideMobile, className, padding = "base" }: Props) => (
	<section
		className={tw(
			"shadow-large w-full rounded-lg",
			className,
			paddings[padding],
			hideMobile && "tablet:p-5 tablet:shadow-large p-0 shadow-none",
		)}
	>
		{children}
	</section>
);

export default Paper;
